<script setup>
import router from '@/router';
import { ref, inject, onMounted } from 'vue';
import { useStore } from 'vuex';

defineOptions({
  name: 'TherapyMenu',
});

const store = useStore();
const emitter = inject('emitter');
const deleteEventName = 'deleteTherapy';

emitter.on(`${deleteEventName}-yes`, async (therapy_id) => {
  await store.dispatch('delete', {
    end_point: 'therapy',
    path_vars: {
      therapy_id,
    },
  });
  store.commit('deleteTherapy', { therapy_id });
  router.go();
});

emitter.on(`${deleteEventName}-no`, () => {});

const deleteTherapy = async (therapy_id) => {
  await store.dispatch('modal/setModal', {
    title: 'Weet je het zeker?',
    text: `Je staat op het punt om therapy (${therapy_id}) te verwijderen, met alle berichten die daar in zitten!`,
    eventName: deleteEventName,
    param: therapy_id,
    type: 'okcancel',
  });
};

const openTherapy = async (therapy_id) => {
  router.push({ path: `/therapy/${therapy_id}` });
};

const therapies = ref([]);

onMounted(async () => {
  therapies.value = await store.dispatch('get', {
    end_point: 'getTherapies',
  });
});
</script>
<template>
  <div class="full">
    <h1 class="title is-size-3-mobile is-size-2-tablet">TherapyMenu</h1>
    <ul v-if="therapies && therapies.length != 0">
      <li v-for="(therapy, index) in therapies" :key="index">
        <button
          class="button is-danger"
          @click="deleteTherapy(therapy.therapy_id)"
        >
          delete therapy
        </button>
        <button class="button" @click="openTherapy(therapy.therapy_id)">
          <span>start: {{ therapy.start_time }}</span>
          <span>id: {{ therapy.therapy_id }}</span>
          <span>total_duration: {{ therapy.total_duration }}</span>
          <span>tokentotaal: {{ therapy.total_tokens_sum }}</span>
          <span>completion: {{ therapy.completion_tokens_sum }}</span>

          <span
            >kosten: $
            {{
              (therapy.completion_tokens_sum / 1000) * 0.002 +
              (therapy.total_tokens_sum / 1000) * 0.0015
            }}</span
          ></button
        ><br />
      </li>
    </ul>
  </div>
</template>
<style scoped>
button {
  display: inline-block;
  & span {
    margin: 0 10px;
  }
}
</style>
